import type { AirspaceRestriction, AirspaceSummaryGroup } from 'hooks/useAirspaceSummary/types';

import { MAX_VISIBLE_RESTRICTIONS } from './constants';

const isControlled = (restriction: AirspaceRestriction): boolean =>
    restriction.severity !== 'info' && restriction.severity !== 'safe';

// Priority: the card whose airspace the pin is INSIDE wins. Backend sets
// distanceM=0 for any layer (laanc_grid, airspace_class, SUA) that contains
// the pin, so pure distance sort promotes it to the top automatically.
// Within each bucket (controlled / awareness), closest wins.
const compareRestrictions = (left: AirspaceRestriction, right: AirspaceRestriction): number => {
    const leftControlled = isControlled(left);
    const rightControlled = isControlled(right);

    if (leftControlled !== rightControlled) {
        return leftControlled ? -1 : 1;
    }

    const leftDistance = left.distanceM ?? Number.POSITIVE_INFINITY;
    const rightDistance = right.distanceM ?? Number.POSITIVE_INFINITY;

    return leftDistance - rightDistance;
};

export const sortRestrictions = (summary: AirspaceSummaryGroup): AirspaceRestriction[] =>
    [...summary.prohibited, ...summary.restricted, ...summary.advisory].sort(compareRestrictions);

export const getVisibleRestrictions = (summary: AirspaceSummaryGroup): AirspaceRestriction[] =>
    sortRestrictions(summary).slice(0, MAX_VISIBLE_RESTRICTIONS);

export const getHiddenCount = (summary: AirspaceSummaryGroup): number =>
    Math.max(0, sortRestrictions(summary).length - MAX_VISIBLE_RESTRICTIONS);
